<template>
  <div class="af-table-wrap">
    <el-button type="primary" @click="addData" style="float: right; margin-bottom: 8px;">新增</el-button>
    <el-table
        class="parae-setting-table"
        :data="list.filter((data) => !search || data.biValue.toLowerCase().includes(search.toLowerCase()))"
        :max-height="tableMaxHeight"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.1)"
      >
        <el-table-column label="id" prop="id" width="60"></el-table-column>
        <el-table-column label="key " prop="biKey"></el-table-column>
        <el-table-column label="token1.0" prop="biValue"></el-table-column>
        <el-table-column label="token2.0" prop="tokenV2"></el-table-column>
        <el-table-column label="备注" prop="remark" width="200"></el-table-column>
        <el-table-column label="操作" prop width="100">
          <template slot-scope="scope">
            <el-button class="edit-btn" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <edit-dialog
        :isNew="isNew"
        :ruleFormProps="ruleFormProps"
        :formVisible="formVisible"
        @closeDialogForm="closeDialogForm"
      ></edit-dialog>
  </div>
</template>

<script>
import EditDialog from "./editDialog";
export default {
  name: "paramsetting",
  mounted() {
    this.getParamSettingList();
  },
  components: {
    EditDialog,
  },
  data() {
    return {
      formVisible: false,
      ruleFormProps: {},
      tableMaxHeight: window.innerHeight - 150,
      loading: false,
      search: '',
      isNew: false,
    };
  },
  computed: {
    list: function () {
      return this.$store.state.ParamSetting.paramsettingList;
    },
  },
  methods: {
    getParamSettingList() {
      this.$store.dispatch("getParamSettingList");
    },
    closeDialogForm(bool) {
      this.formVisible = bool;
    },
    addData() {
      this.formVisible = true;
      this.isNew = true;
      this.ruleFormProps = {
        id: "",
        biKey: "",
        biValue: "",
        remark: "",
      };
    },
    handleEdit(row) {
      this.formVisible = true;
      this.isNew = false;
      this.ruleFormProps = { ...row };
    },
  },
};
</script>
<style lang="less" scoped>
.af-table-wrap {
  height: 100%;
  .top-header {
    text-align: right;
    margin-bottom: 4px;
  }
}
</style>
